



























































































































































import Vue from "vue"
import { Address } from "@/model/entity/address/address.ts"
import { addressService } from "@/model/service/address/address-service.ts"
import { countryList } from "@/model/service/country/country-service"

export default Vue.extend({
  components: {},
  data() {
    return {
      address: new Address(),
      addressService: addressService,
      countryList: countryList,
      isFormValid: false,
      rules: {
        name: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        country: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        zipcode: [
          {
            max: 30,
            message: `${this.$t("user_administration.max")} 30 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        city: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        street: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        houseNumber: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 6 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        phone: [
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.phone")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        email: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              const regexpPattern = /^[\w!#$%&’*+/=?`{|}~^-]+(?:\.[\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
              if (value && !new RegExp(regexpPattern).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.email")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        mobile: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.mobile")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        contact: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        comment: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        fax: [
          {
            max: 30,
            message: `${this.$t("user_administration.max")} 30 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        ownCode: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ]
      }
    }
  },
  props: {},
  methods: {
    save() {
      const vm = this
      vm.startLoad()
      vm.addressService
        .create(vm.address)
        .then(() => {
          vm.$router.push({ path: "list_addresses" })
        })
        .catch((e: any) => {
          vm.endLoad()
          vm.$error(e.response.data.message)
        })
    },
    validated() {
      const vm = this as any
      let isAddressValid
      vm.$refs.form.validate(valid => {
        isAddressValid = valid
      })
      this.isFormValid = isAddressValid && exists(this.address.country)
    },
    fuzzySearchCity(input: string, callback: any) {
      if (input && input.length >= 3 && this.address.country) {
        this.$http
          .get("cities/fuzzy/cities?country_code=" + this.address.country.isoCodeAlpha2 + "&city=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    fuzzySearchZipcode(input: string, callback: any) {
      if (input && input.length >= 3 && this.address.country) {
        this.$http
          .get("cities/fuzzy/zipcodes?country_code=" + this.address.country.isoCodeAlpha2 + "&zipcode=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    setCityAndZipcode(entity: any) {
      this.address.city = entity.name
      this.address.zipcode = entity.postalCode
    }
  },
  watch: {
    address: {
      handler() {
        this.validated()
      },
      deep: true
    }
  },
  mounted() {
    this.validated()
  }
})
